function Footer() {
  return (
    <footer className="footer footer-center p-4 bg-base-300 text-base-content mt-2">
      <div>
        <p className="text-[10px] sm:text-base">Copyright &copy; 2022 - All rights reserved by House of Music & Love, LLC</p>
      </div>
    </footer>
  )
}

export default Footer